export const checkisCoupon = (value: string) => {
    const arr = value.trim().split('')
    if (arr.length < 5) return false
    return arr.every(el => /^\d+$/.test(el))
  }